import React from 'react';
import { MapPin, PenTool, Award, Shield, ThumbsUp } from 'lucide-react';
export function WhyChoose() {
  const reasons = [{
    title: 'Local Michigan Glass Experts',
    copy: 'Family-owned since 2000 and serving homeowners throughout Howell, Ann Arbor, Novi and Southeast Michigan.',
    icon: MapPin
  }, {
    title: 'Custom Design & Measurement',
    copy: "Kosin's Glass reviews your bathroom, takes proper measurements and helps design the right shower glass solution.",
    icon: PenTool
  }, {
    title: 'Professional Installation',
    copy: 'Experienced glass technicians install custom shower doors and enclosures with attention to fit, safety and finish.',
    icon: Award
  }, {
    title: 'Quality Glass & Hardware',
    copy: 'Choose from quality glass, trusted shower lines, 18 glass designs and textures, and many hardware finishes.',
    icon: Shield
  }, {
    title: 'No High-Pressure Sales',
    copy: 'Get clear recommendations, options and a free in-home quote before making a decision.',
    icon: ThumbsUp
  }, {
    title: 'Lifetime Installation Guarantee',
    copy: "Kosin's shower door installations are backed by a lifetime guarantee.",
    icon: Shield
  }];
  return <section className="py-20 bg-white" data-id="element-1749">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-1750">
        <div className="text-center max-w-3xl mx-auto mb-16 anim-on-scroll" data-id="element-1751">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-6 tracking-tight" data-id="element-1752">
            Why Choose Kosin's Glass for Shower Doors?
          </h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1753">
          {reasons.map((reason, i) => <div key={i} className="bg-gray-50 p-8 rounded-2xl border border-gray-100 flex gap-4 scroll-fade-up" style={{
          animationDelay: `${i * 0.1}s`
        }} data-id="element-1754">
              <div className="shrink-0 mt-1" data-id="element-1755">
                <reason.icon className="w-6 h-6 text-primary" data-id="element-1756" />
              </div>
              <div data-id="element-1757">
                <h3 className="text-lg font-bold text-navy mb-2" data-id="element-1758">
                  {reason.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-1759">
                  {reason.copy}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}